/**
 * Grill King PDP gallery — keep thumbnail strip as a scroller.
 */
(function () {
  'use strict';

  function enhance(gallery) {
    if (!gallery || gallery.dataset.egjGalleryBound === '1') return;

    var thumbs = gallery.querySelector('.egj-pdp-thumbs__list, .thumbnail-list');
    if (!thumbs) return;

    gallery.dataset.egjGalleryBound = '1';

    function scrollActiveIntoView() {
      var list = gallery.querySelector('.egj-pdp-thumbs__list, .thumbnail-list');
      var active = list && list.querySelector('[aria-current="true"]');
      var item = active && active.closest('.thumbnail-list__item');
      if (!item || typeof item.scrollIntoView !== 'function') return;
      item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    gallery.addEventListener('click', function (event) {
      if (!event.target.closest('.thumbnail')) return;
      window.requestAnimationFrame(function () {
        scrollActiveIntoView();
        syncNavState();
        layoutThumbs();
      });
    });

    gallery.addEventListener(
      'keyup',
      function (event) {
        if (event.code !== 'ArrowLeft' && event.code !== 'ArrowRight') return;
        window.requestAnimationFrame(scrollActiveIntoView);
      },
      true
    );

    /* Dawn only maintains the counter while the stage is a swipe slider; on the
       desktop thumbnail layout the active slide changes without it. */
    function syncCounter() {
      var slides = gallery.querySelectorAll('.product__media-item');
      var current = gallery.querySelector('.slider-counter--current');
      var total = gallery.querySelector('.slider-counter--total');
      if (!slides.length || !current) return;

      var index = 0;
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i].classList.contains('is-active')) {
          index = i;
          break;
        }
      }

      var next = String(index + 1);
      var count = String(slides.length);
      if (current.textContent !== next) current.textContent = next;
      if (total && total.textContent !== count) total.textContent = count;
    }

    /* Dawn's slider writes NaN/-Infinity here when the stage isn't a slider. */
    var counter = gallery.querySelector('.slider-counter');
    if (counter && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        syncCounter();
      }).observe(counter, { subtree: true, childList: true, characterData: true });
    }

    /* On desktop the stage is not a Dawn slider, so its prev/next buttons stay
       disabled. Drive the media through the thumbnails instead and own the
       disabled state, which keeps one set of arrows for both breakpoints. */
    var DESKTOP_MQ = '(min-width: 750px)';

    function isManual() {
      return window.matchMedia(DESKTOP_MQ).matches;
    }

    function thumbButtons() {
      return Array.prototype.slice.call(
        gallery.querySelectorAll('.thumbnail-list__item .thumbnail')
      );
    }

    function activeThumbIndex(buttons) {
      for (var i = 0; i < buttons.length; i += 1) {
        if (buttons[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function navButton(name) {
      return gallery.querySelector('.egj-pdp-gallery__nav .slider-button[name="' + name + '"]');
    }

    function syncNavState() {
      if (!isManual()) return;

      var buttons = thumbButtons();
      if (buttons.length < 2) return;

      var index = activeThumbIndex(buttons);
      var prev = navButton('previous');
      var next = navButton('next');
      var wantPrev = index <= 0;
      var wantNext = index >= buttons.length - 1;
      if (prev && prev.disabled !== wantPrev) prev.disabled = wantPrev;
      if (next && next.disabled !== wantNext) next.disabled = wantNext;
    }

    /* Dawn's SliderComponent disables both arrows whenever the stage has no
       horizontal overflow, which on desktop is always. Re-assert after it. */
    function watchNavState() {
      if (typeof MutationObserver !== 'function') return;

      var nav = gallery.querySelector('.egj-pdp-gallery__nav');
      if (!nav) return;

      new MutationObserver(function () {
        syncNavState();
      }).observe(nav, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }

    function step(delta) {
      var buttons = thumbButtons();
      if (!buttons.length) return false;

      var target = buttons[activeThumbIndex(buttons) + delta];
      if (!target) return false;

      target.click();
      window.requestAnimationFrame(function () {
        scrollActiveIntoView();
        syncNavState();
        syncCounter();
        layoutThumbs();
      });
      return true;
    }

    gallery.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.egj-pdp-gallery__nav .slider-button');
        if (!button || !isManual()) return;

        event.preventDefault();
        event.stopPropagation();
        step(button.name === 'previous' ? -1 : 1);
      },
      true
    );

    /* Arrow keys drive the stage whenever focus is anywhere in the gallery. */
    gallery.addEventListener('keydown', function (event) {
      if (event.code !== 'ArrowLeft' && event.code !== 'ArrowRight') return;
      if (event.target.closest('.thumbnail-list')) return;

      var delta = event.code === 'ArrowLeft' ? -1 : 1;

      if (isManual()) {
        if (step(delta)) event.preventDefault();
        return;
      }

      var button = navButton(delta === -1 ? 'previous' : 'next');
      if (!button || button.disabled) return;
      event.preventDefault();
      button.click();
    });

    /* Desktop rail is a fixed row of tiles ending in a "+N" tile that opens the
       full media modal, so the strip never scrolls out of the viewport.
       Column count lives in CSS so the breakpoints stay in one place. */
    function thumbItems() {
      return Array.prototype.slice.call(
        gallery.querySelectorAll('.thumbnail-list__item:not(.egj-pdp-thumbs__item--more)')
      );
    }

    function columnCount(list) {
      var declared = parseInt(
        window.getComputedStyle(list).getPropertyValue('--pdpg-thumb-cols'),
        10
      );
      return declared > 1 ? declared : 0;
    }

    function openMediaModal() {
      var toggle = gallery.querySelector('.product__media-item.is-active .product__media-toggle');
      if (toggle) toggle.click();
    }

    function moreTile(list) {
      var existing = list.querySelector('.egj-pdp-thumbs__item--more');
      if (existing) return existing;

      var item = document.createElement('li');
      item.className = 'thumbnail-list__item egj-pdp-thumbs__item--more';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'egj-pdp-thumbs__more';
      button.addEventListener('click', openMediaModal);

      item.appendChild(button);
      list.appendChild(item);
      return item;
    }

    function layoutThumbs() {
      var list = gallery.querySelector('.egj-pdp-thumbs__list, .thumbnail-list');
      if (!list) return;

      var items = thumbItems();
      var cols = columnCount(list);
      var more = list.querySelector('.egj-pdp-thumbs__item--more');

      function reset() {
        items.forEach(function (item) {
          item.classList.remove('egj-pdp-thumbs__item--hidden');
          item.style.order = '';
        });
      }

      /* Mobile keeps the scroller, and short galleries need no overflow tile */
      if (!isManual() || !cols || items.length <= cols) {
        reset();
        if (more) more.remove();
        return;
      }

      reset();

      var limit = cols - 1;
      var activeIndex = activeThumbIndex(thumbButtons());

      for (var i = limit; i < items.length; i += 1) {
        items[i].classList.add('egj-pdp-thumbs__item--hidden');
      }

      /* Keep the selected media visible even when it lives past the cut-off */
      if (activeIndex >= limit) {
        items[activeIndex].classList.remove('egj-pdp-thumbs__item--hidden');
        items[activeIndex].style.order = String(limit);
        items[limit - 1].classList.add('egj-pdp-thumbs__item--hidden');
      }

      var tile = moreTile(list);
      tile.style.order = String(limit + 1);
      tile.querySelector('.egj-pdp-thumbs__more').textContent = '+' + (items.length - limit);
      tile
        .querySelector('.egj-pdp-thumbs__more')
        .setAttribute('aria-label', 'View all ' + items.length + ' media items');

      var firstHidden = items.filter(function (item) {
        return item.classList.contains('egj-pdp-thumbs__item--hidden');
      })[0];
      var previewImg = firstHidden && firstHidden.querySelector('img');
      var previewSrc = previewImg && (previewImg.currentSrc || previewImg.src);
      if (previewSrc) {
        tile.querySelector('.egj-pdp-thumbs__more').style.setProperty('--pdpg-more-img', 'url("' + previewSrc + '")');
      }
    }

    /* Badge mirrors the active media type; images get no badge. */
    function syncBadge() {
      var host = gallery.querySelector('slider-component');
      var active = gallery.querySelector('.product__media-item.is-active');
      if (!host || !active) return;

      var label = '';
      if (active.querySelector('product-model, model-viewer')) {
        label = '360° view';
      } else if (active.querySelector('video, iframe')) {
        label = 'Video';
      }

      var badge = host.querySelector('.egj-pdp-gallery__badge');

      if (!label) {
        if (badge) badge.remove();
        return;
      }

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'egj-pdp-gallery__badge';
        host.appendChild(badge);
      }

      badge.textContent = label;
    }

    /* Expand button that opens the full-screen viewer
       (egj-gallery-viewer.js intercepts the toggle click). */
    function addStageChrome() {
      var host = gallery.querySelector('slider-component');
      var slideCount = gallery.querySelectorAll('.product__media-item').length;
      if (!host) return;

      if (!host.querySelector('.egj-pdp-gallery__expand')) {
        var expand = document.createElement('button');
        expand.type = 'button';
        expand.className = 'egj-pdp-gallery__expand';
        expand.setAttribute('aria-label', 'Open full-screen gallery');
        expand.innerHTML =
          '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>' +
          '<span>' + (slideCount > 1 ? 'View ' + slideCount + ' photos' : 'Expand') + '</span>';
        expand.addEventListener('click', openMediaModal);
        host.appendChild(expand);
      }
    }

    /* Hover magnifier: scale the active photo around the cursor and swap in a
       sharper rendition the first time. Fine pointers on desktop only. */
    function bindMagnifier() {
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var stage = gallery.querySelector('.product__media-list');
      if (!stage) return;

      var activeItem = null;
      var frame = 0;
      var point = null;

      function itemFrom(target) {
        var item = target && target.closest && target.closest('.product__media-item.is-active');
        if (!item || !item.querySelector('.product__modal-opener--image')) return null;
        return item;
      }

      function stop() {
        if (activeItem) activeItem.classList.remove('is-magnifying');
        gallery.classList.remove('is-magnifying');
        activeItem = null;
      }

      function paint() {
        frame = 0;
        if (!activeItem || !point) return;
        var media = activeItem.querySelector('.product__media');
        var rect = media.getBoundingClientRect();
        var x = Math.min(100, Math.max(0, ((point.x - rect.left) / rect.width) * 100));
        var y = Math.min(100, Math.max(0, ((point.y - rect.top) / rect.height) * 100));
        activeItem.style.setProperty('--pdpg-mx', x + '%');
        activeItem.style.setProperty('--pdpg-my', y + '%');
      }

      stage.addEventListener('pointermove', function (event) {
        if (event.pointerType !== 'mouse' || !canHover.matches || reduce.matches || !isManual()) return;
        if (event.target.closest('.egj-drawing-trigger, .egj-pdp-gallery__nav, .egj-pdp-gallery__expand')) {
          stop();
          return;
        }
        var item = itemFrom(event.target);
        if (!item) {
          stop();
          return;
        }
        if (item !== activeItem) {
          stop();
          activeItem = item;
          var img = item.querySelector('.product__media img');
          if (img && !img.dataset.pdpgHires) {
            img.dataset.pdpgHires = '1';
            img.sizes = Math.round(item.getBoundingClientRect().width * 2.4) + 'px';
          }
          item.classList.add('is-magnifying');
          gallery.classList.add('is-magnifying');
        }
        point = { x: event.clientX, y: event.clientY };
        if (!frame) frame = window.requestAnimationFrame(paint);
      });

      stage.addEventListener('pointerleave', stop);
      window.addEventListener('scroll', stop, { passive: true });
      gallery.addEventListener('click', stop, true);
    }

    addStageChrome();
    bindMagnifier();

    var resizeTimer = null;
    window.addEventListener(
      'resize',
      function () {
        syncNavState();
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(layoutThumbs, 120);
      },
      { passive: true }
    );

    watchNavState();
    syncNavState();
    layoutThumbs();
    syncBadge();

    var stage = gallery.querySelector('.product__media-list');
    if (stage && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        syncCounter();
        syncBadge();
      }).observe(stage, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    syncCounter();
  }

  function init() {
    document.querySelectorAll('media-gallery.egj-pdp-gallery, media-gallery.fp-pdp-gallery').forEach(enhance);
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
